function setIEversion(v){
  var b = document.querySelector("body");

  if (v < 12) {
    // Set classes if lower than Edge
    b.classList.add("ie");
    b.classList.add(("ie-"+v));
  }
  else{
    // Set classes if Edge
    b.classList.add("edge");
    b.classList.add(("edge-"+v));
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
DOMReady(function() {
  var IEversion = detectIE();
  if(IEversion) setIEversion(IEversion);
});